// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.repeatable-field-container {
  flex: 1;
}
.repeatable-field-container .add-btn {
  background-color: transparent;
  border-style: none;
  padding: 0;
  margin-bottom: 24px;
  text-decoration: underline;
}
.repeatable-field-container .accordion-item {
  margin-bottom: 12px;
}
.repeatable-field-container .accordion-item .accordion-header {
  display: flex;
  gap: 8px;
}
.repeatable-field-container .accordion-item .accordion-header .left-part,
.repeatable-field-container .accordion-item .accordion-header .right-part {
  display: flex;
  align-items: center;
  gap: 6px;
}
.repeatable-field-container .accordion-item .accordion-header .left-part input {
  flex: 0 0 375px;
  width: 375px;
  max-width: 100%;
}
.repeatable-field-container .accordion-item .accordion-header .right-part {
  flex: 1;
}`, "",{"version":3,"sources":["webpack://./src/components/RepeatableField/RepeatableField.scss"],"names":[],"mappings":"AAAA;EACC,OAAA;AACD;AAAC;EACC,6BAAA;EACA,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,0BAAA;AAEF;AAAC;EACC,mBAAA;AAEF;AADE;EACC,aAAA;EACA,QAAA;AAGH;AAFG;;EAEC,aAAA;EACA,mBAAA;EACA,QAAA;AAIJ;AADI;EACC,eAAA;EACA,YAAA;EACA,eAAA;AAGL;AAAG;EACC,OAAA;AAEJ","sourcesContent":[".repeatable-field-container {\n\tflex: 1;\n\t.add-btn {\n\t\tbackground-color: transparent;\n\t\tborder-style: none;\n\t\tpadding: 0;\n\t\tmargin-bottom: 24px;\n\t\ttext-decoration: underline;\n\t}\n\t.accordion-item {\n\t\tmargin-bottom: 12px;\n\t\t.accordion-header {\n\t\t\tdisplay: flex;\n\t\t\tgap: 8px;\n\t\t\t.left-part,\n\t\t\t.right-part  {\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tgap: 6px;\n\t\t\t}\n\t\t\t.left-part {\n\t\t\t\tinput {\n\t\t\t\t\tflex: 0 0 375px;\n\t\t\t\t\twidth: 375px;\n\t\t\t\t\tmax-width: 100%;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.right-part {\n\t\t\t\tflex: 1;\n\t\t\t}\n\t\t}\n\t\t.accordion-content {\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
